import React, { Component } from 'react';
import ConditionedComponent from 'components/ConditionedComponent.js';
import LinkedMemberModal from './LinkedMemberModal.js';

class LinkedMembers extends Component {
    constructor(props) {
        super(props);

        this.state = {
            members: [],
            selectedMember: undefined,
        };

        this.fetchMembers();
    }

    async fetchMembers() {
    }

    onClickMember(member) {
        if (member.guildName === '') {
            this.setState({selectedMember: member});
        } else {
            window.open('/user/' + member.userName, '_blank');
        }
    }

    onHideModal() {
        console.log('on hide');
        this.setState({selectedMember: undefined});
    }

    getLinkedMembers() {
        if (this.props.selectedGuild === undefined) {
            return this.state.members;
        }
        return this.state.members.filter(
            x => x.guildId ===  this.props.selectedGuild);
    }

    render() {
        return (
            <div className="linked-members">
              <LinkedMemberModal
                ethereum={this.props.ethereum}
                hide={() => this.onHideModal()} member={this.state.selectedMember}/>
              <div className="linked-count">You are connected to <span className="linked-count-number"> {this.state.members.length} </span> artists</div>
              {this.getLinkedMembers().map(
                  member =>
                      <LinkedMember
                            onClickMember={() => this.onClickMember(member)}
                        member={member}/>)}
            </div>
        );
    }
}

class LinkedMember extends Component {
    render() {
        return (
            <div
              onClick={this.props.onClickMember}
              className="linked-member">
              <div className="linked-user-name">{this.props.member.userName} </div>
              <ConditionedComponent condition={this.props.member.guildName !== ''}>
                <div className="guild-name">{this.props.member.guildName}</div>
              </ConditionedComponent>
            </div>
        );
    }
}

export default LinkedMembers;
